import PropTypes from "prop-types";
import Logo from "components/common/Logo";

export default function AuthSplitLayout({
  children,
  heroTitle = "Welcome to Fortify Backoffice",
  heroDescription = "Manage projects, community, and investment workflows from one secure dashboard.",
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 p-4 md:p-8">
      <div className="w-full max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl">
        <div className="grid min-h-[620px] md:grid-cols-2">
          <section className="flex items-center p-8 sm:p-10">{children}</section>

          <section className="hidden bg-gradient-to-b from-blue-800 to-blue-600 p-10 text-white md:flex md:items-center md:justify-center">
            <div className="max-w-sm text-center">
              <Logo
                className="mx-auto mb-5 justify-center"
                logoClassName="h-12 w-12"
                showText
                text="Fortify"
                textClassName="text-3xl font-bold text-white"
              />
              <h2 className="text-4xl font-bold leading-tight">{heroTitle}</h2>
              <p className="mt-4 text-sm text-blue-100">{heroDescription}</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

AuthSplitLayout.propTypes = {
  children: PropTypes.node.isRequired,
  heroTitle: PropTypes.string,
  heroDescription: PropTypes.string,
};
